// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-09T08:47:04.858Z",
  gitInfo: {
    dirty: false,
    raw: "eb94b2948",
    hash: "eb94b2948",
    distance: null,
    tag: null,
    semver: null,
    suffix: "eb94b2948",
    semverString: null
  }
};
/* tslint:enable */
